import React from 'react';
import mStyles from './skeleton.module.sass';
import classNames from 'classnames';

const Skeleton = ({
    className,
    width,
    height,
    radius,
    kind = 'rectangular', // rectangular | circular
    ...rest
}) => {
    const skeletonClass = classNames(mStyles.skeleton, {
        [mStyles.skeleton__rectangle]: kind === 'rectangular',
        [mStyles.skeleton__circle]: kind === 'circular',
    }, className);

    return (
        <div
            {...rest}
            className={skeletonClass}
            style={{
                width,
                height,
                borderRadius: radius,
            }}
        />
    );
};

export default {
    Rectangular: ({width, height, ...rest}) =>
        <Skeleton {...rest} width={width} height={height} kind="rectangular" />,
    Circular: ({size, radius, ...rest}) =>
        <Skeleton {...rest} width={size} height={size} radius={radius} kind="circular" />,
};
